import { CompanyType } from 'app/constants/companyType'

export const getCompanyTypeName = (
  type: CompanyType | boolean,
  isAccountingOnly: boolean,
): string => {
  if (isAccountingOnly) {
    return 'administrationPanel-companies.company-type-accountingOnly'
  }

  // `type` may arrive as the CompanyType enum (single-company / mapFields path) OR as the
  // raw backend boolean IsServiceCompany (some list/grid paths). Handle both so the RODZAJ
  // column never falls back to an untranslatable '-'. Unknown -> Normal (sensible default).
  const isService = type === CompanyType.SERVICE || type === true
  return isService
    ? 'administrationPanel-companies.company-type-service'
    : 'administrationPanel-companies.company-type-normal'
}
